import { render, staticRenderFns } from "./SundryCreditorView.vue?vue&type=template&id=5a1512f6"
import script from "./SundryCreditorView.vue?vue&type=script&lang=js"
export * from "./SundryCreditorView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports